import { PsCustomer } from '@h5s/entities';
import { MappedClass } from '@h5s/util-object';

@MappedClass()
export class TablePsCustomer extends PsCustomer {
  get guestsNumber(): number {
    return this.relatives?.length + 1 || 0;
  }

  constructor(init?: Partial<TablePsCustomer>) {
    super(init);
  }
}
